export default function translateValues() {
  let query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    target = 'lsc'
  } = options;
  switch (target) {
    case 'lsc':
      query = Object.entries(query).reduce((acc, _ref) => {
        let [key, value] = _ref;
        return {
          ...acc,
          // ignores dealerName because some dealer name contains ","
          // for example "Autosource Motors, Inc." and we should not split it into two items
          [key]: key !== 'dealerName' && typeof value === 'string' && value.includes(',') ? value.split(',') : value
        };
      }, {});
      break;
    case 'cs':
      query = Object.entries(query).reduce((acc, _ref2) => {
        let [key, value] = _ref2;
        return {
          ...acc,
          [key]: Array.isArray(value) ? value.join(',') : value
        };
      }, {});
      break;
    default:
  }
  return query;
}